import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { supabase } from "./utils/supabaseClient";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Services from "./pages/Services";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import DashboardLayout from "./components/DashboardLayout";
import WebinarManagement from "./pages/WebinarManagement";
import ProductManagement from "./pages/ProductManagement";
import IndustriesManagement from "./pages/IndustriesManagement";
import "./styles/App.css";
import AssetLoader from "./components/AssetLoader";
import Products from "./pages/Products";
import Footer from "./components/Footer";
import PartnerManagement from "./pages/PartnerManagement";
import OfficesManagement from "./pages/OfficesManagement";
import About from "./pages/About";

/* Version 1.2.0 Infinipoint Technologies Private Limited */

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkUser();

    // Subscribe to auth state changes
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setIsAuthenticated(!!session);
      setLoading(false);
    });

    return () => {
      subscription?.unsubscribe();
    };
  }, []);

  async function checkUser() {
    try {
      const {
        data: { session },
        error,
      } = await supabase.auth.getSession();
      if (error) throw error;
      setIsAuthenticated(!!session);
    } catch (error) {
      console.error("Error checking auth status:", error.message);
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  }

  const ProtectedRoute = ({ children }) => {
    if (loading) {
      return <AssetLoader />;
    }

    if (!isAuthenticated) {
      return <Navigate to="/login" replace />;
    }
    return children;
  };

  if (loading) {
    return <AssetLoader />;
  }

  return (
    <Router>
      <div className="app">
        {/* <Maintenance /> */}
        <Routes>
          Dashboard Routes - No Navbar or Footer
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardLayout>
                  <Dashboard />
                </DashboardLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/webinars"
            element={
              <ProtectedRoute>
                <DashboardLayout>
                  <WebinarManagement />
                </DashboardLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/partners"
            element={
              <ProtectedRoute>
                <DashboardLayout>
                  <PartnerManagement />
                </DashboardLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/products"
            element={
              <ProtectedRoute>
                <DashboardLayout>
                  <ProductManagement />
                </DashboardLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/industries"
            element={
              <ProtectedRoute>
                <DashboardLayout>
                  <IndustriesManagement />
                </DashboardLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/offices"
            element={
              <ProtectedRoute>
                <DashboardLayout>
                  <OfficesManagement />
                </DashboardLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/about"
            element={
              <ProtectedRoute>
                <DashboardLayout>
                  <About />
                </DashboardLayout>
              </ProtectedRoute>
            }
          />
          Main Routes - Include Navbar and Footer
          <Route
            path="/*"
            element={
              <>
                <Navbar />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/about" element={<AboutUs />} />
                  <Route path="/contact" element={<ContactUs />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/products" element={<Products />} />
                  <Route path="/products/:partnerId" element={<Products />} />
                </Routes>
                <Footer />
              </>
            }
          />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
